import { ShieldOff } from 'lucide-react';

export default function SANoAccessPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center gap-4">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-muted">
        <ShieldOff className="h-8 w-8 text-muted-foreground" />
      </div>
      <div>
        <h2 className="text-lg font-semibold text-foreground">No sections assigned</h2>
        <p className="mt-1 text-sm text-muted-foreground max-w-xs">
          Your account hasn't been granted access to any Super Admin sections yet.
          Please contact the Super Admin to get access.
        </p>
      </div>
    </div>
  );
}
